/**
 * Hook for accessing the DocumentComparison context.
 */

import { useContext } from 'react';
import { DocumentComparisonContext } from '../DocumentComparisonProvider';
import type { DocumentComparisonContextValue } from '../types';

/**
 * Access the DocumentComparison context.
 * Must be used within a DocumentComparisonProvider.
 */
export function useDocumentComparison(): DocumentComparisonContextValue {
  const context = useContext(DocumentComparisonContext);

  if (!context) {
    throw new Error(
      'useDocumentComparison must be used within a DocumentComparisonProvider',
    );
  }

  return context;
}
